import DefaultCatalogConfig from './DefaultCatalogConfig';

export default class UncategorizedCatalogConfig extends DefaultCatalogConfig {
  allowHoverActions = true;

  canPaste = () => false;

  indentTree = false;
}
